import {
  DIRECTORY_STORES_OMVS,
  DIRECTORY_STORES_OMVS_ERROR,
  CLEAN_DIRECTORY_STORES_OMVS,
  CLEAN_DIRECTORY_STORES_OMVS_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function directoryStoreOmvsReducer(state = initialState, action) {
  switch (action.type) {
    case DIRECTORY_STORES_OMVS:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case DIRECTORY_STORES_OMVS_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_DIRECTORY_STORES_OMVS:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_DIRECTORY_STORES_OMVS_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
